import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { usePageChrome } from './pageChrome';
import { lookupRouteMeta } from './routeMeta';

const BASE_TITLE = 'Rose';

/**
 * The only writer of `document.title`, mounted once above every route.
 *
 * Title source, in order: the active surface's registered chrome (a `<Page>`, or
 * an `OnboardingShell` outside the layout), then the route's ROUTE_META entry.
 * Centralising it is what closes the gap where full-screen surfaces mounted
 * outside AppLayout never went through `<Page>` and left the tab reading "Rose"
 * for the whole flow.
 */
export function DocumentTitle() {
    const chrome = usePageChrome();
    const { pathname } = useLocation();
    const title = chrome?.title || lookupRouteMeta(pathname)?.title;

    useEffect(() => {
        document.title = title ? `${title} · ${BASE_TITLE}` : BASE_TITLE;
        return () => {
            document.title = BASE_TITLE;
        };
    }, [title]);

    return null;
}
